// import components
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { DatePicker } from 'components/shared';
import { Icon } from '@sdb/planning-ui';

// import external libraries
import { addYears, startOfToday, startOfYear } from 'date-fns';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// import styles
import { StyledBoxFlex } from '../Box/Box.styles';

// import types
import { OptionalEndDateProps } from './OptionalEndDate.types';

// @TODO: Replace all instances of this component with OptionalDatePicker
export default function OptionalEndDate({
  date = null,
  onDateChanged,
  readonly,
  hideRemove,
  disabled
}: OptionalEndDateProps) {
  const { t } = useTranslation('common');
  const [showPicker, setShowPicker] = useState(false);
  const [addedInitialDate, setAddedInitialDate] = useState(true);

  useEffect(() => {
    if (addedInitialDate && date) {
      setShowPicker(true);
      setAddedInitialDate(false);
    }
  }, [date, addedInitialDate]);

  if (date) {
    return (
      <StyledBoxFlex>
        <DatePicker
          date={date}
          onChange={(newDate) => {
            onDateChanged(newDate);
            setShowPicker(false);
          }}
          label={t('endDate')}
          open={showPicker}
          readOnly={readonly}
          disabled={disabled}
        />
        {!hideRemove && !readonly && (
          <Tooltip title={t('removeEndDate') || ''}>
            <IconButton
              onClick={() => {
                onDateChanged(null);
                setShowPicker(false);
              }}
            >
              <Icon type="xmark" />
            </IconButton>
          </Tooltip>
        )}
      </StyledBoxFlex>
    );
  }

  if (!readonly) {
    return (
      <Button
        variant="outlined"
        onClick={() => {
          onDateChanged(startOfYear(addYears(startOfToday(), 1)));
          setAddedInitialDate(true);
        }}
      >
        {t('addEndDate')}
      </Button>
    );
  }

  return null;
}
